module.exports = __webpack_public_path__ + "img/xiuxian.14e21274.jpg";